import Container from '@mui/material/Container';
// components
import SecurityTabTable from '../security-tab-table';
import SecurityCertificationView from '../cerification-view';

export default function SecurityPageView() {
  
  return (
    <>
      <Container
        sx={{
          pt: 4,
          pb: 10,
          position: 'relative',
        }}
      >
        <span style={{ display: 'none' }}>Simple translate</span>
        <h1>Security</h1>
        <p>Security Page</p>
        <SecurityTabTable />
        {/* <SecurityCertificationView /> */}
      </Container>
    </>
  );
}
